export default {"src":"/_next/static/media/woflv-icon.bc057d3d.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};